<li class="dashletActivities__item">
  <div class="dashletActivities__item-wrapper">
    <div
      ppTooltip
      class="dashletActivities__item-avatar"
      ppTitle="{{ ppActivity.header.createdBy.caption || ppActivity.header.createdBy['userName'] }}"
    >
      @if (!ppActivity.header.createdBy.primaryImageId) {
        <img
          ppImage
          class="dashletActivities__item-avatar--img"
          [src]="EIconPath.BASIC_FIELD_ASSIGNEES"
        />
      }

      @if (ppActivity.header.createdBy.primaryImageId) {
        <img
          ppImage
          class="dashletActivities__item-avatar--img"
          [ppSecureSrc]="
            'api/v1/images/' + ppActivity.header.createdBy.primaryImageId + '/file/size/square/40'
          "
        />
      }
    </div>

    <div class="dashletActivities__item-center">
      @if (ppWorkspaces[ppActivity.workspaceRef.id]) {
        <div class="dashletActivities__item-center-top">
          <span class="dashletActivities__item-acc-site">
            {{ ppWorkspaces[ppActivity.workspaceRef.id]?.accountName }} -
            {{ ppWorkspaces[ppActivity.workspaceRef.id]?.siteName }} -
          </span>
          @if (ppActivity.data.ref && ppActivity.data.ref.type === 'DefectType') {
            <span
              class="dashletActivities__item-center-top-author"
              (click)="openPoint(ppActivity.workspaceRef.id, ppActivity.data.ref.id)"
            >
              {{ ppActivity.data.ref.sequenceNumber }} - {{ ppActivity.data.ref.caption }}
            </span>
          }
        </div>
      }

      <div class="dashletActivities__item-center-bottom">
        <div class="dashletActivities__item-activities">
          @if (ppActivity.activityType === dashletAcitivities.DELETE) {
            <pp-dashlet-activity-delete> </pp-dashlet-activity-delete>
          }

          @if (ppActivity.data.changeList?.length && ppActivity.data.changeList.length > 0) {
            @if (ppActivity.activityType === dashletAcitivities.POINT_COPY) {
              <pp-dashlet-activity-copy [ppChange]="ppActivity.data.changeList[0]" />
            }

            @if (ppActivity.activityType === dashletAcitivities.POINT_MOVE) {
              <pp-dashlet-activity-move [ppChange]="ppActivity.data.changeList[0]" />
            }
          }

          @if (
            ppActivity.activityType === dashletAcitivities.NEW_DOCUMENT && !ppActivity.data.comment
          ) {
            <pp-dashlet-activity-new-point />
          }

          @if (
            ppActivity.activityType === dashletAcitivities.NEW_DOCUMENT && ppActivity.data.comment
          ) {
            <pp-dashlet-activity-new-comment
              [ppRichText]="ppActivity.data.commentRich"
              [ppPlainText]="ppActivity.data.comment"
            />
          }

          @if (ppActivity.activityType === dashletAcitivities.UPDATE_CHANGES) {
            <pp-dashlet-activity-update-changes
              [ppAllUsers]="ppAllUsers"
              [ppActivity]="ppActivity"
            />
          }
        </div>

        <p
          ppTooltip
          [ppTitle]="ppActivity.header.timeStampHover"
          class="dashletActivities__item-date"
        >
          <i class="dashletActivities__item-dateIcon fa fa-clock" aria-hidden="true"></i>
          {{ ppActivity.header.formattedDatetime }}
        </p>
      </div>
    </div>
  </div>
</li>
